var html = require('choo/html')
var raw = require('choo/html/raw')
var Nanocomponent = require('nanocomponent')
var css = 0
var header = require('../tmpl/header.js')

var prefix = ((require('sheetify/insert')("@import url(\"https://fonts.googleapis.com/css?family=Lato|Lora|Cousine\");\n._c4937b9e {\n  position: relative;\n  margin-bottom: 3.125rem;\n  font-family: 'Lato', Georgia, serif; }\n  ._c4937b9e .header-wrap {\n    padding-top: 2.25rem;\n    display: flex;\n    flex-direction: column; }\n    ._c4937b9e .header-wrap img {\n      width: 80px;\n      height: 80px;\n      border-radius: 50%;\n      margin-bottom: 0.3125rem; }\n    ._c4937b9e .header-wrap h1 {\n      text-align: center; }\n    ._c4937b9e .header-wrap p {\n      font-size: 1.1875rem;\n      text-align: center;\n      width: 45%;\n      padding-bottom: 2rem;\n      margin-bottom: 0.75rem;\n      border-bottom: 0.03125rem #eee solid;\n      color: #aeaeae;\n      font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;\n      font-weight: 300;\n      font-style: normal;\n      -webkit-font-smoothing: antialiased;\n      text-rendering: optimizeLegibility; }\n      ._c4937b9e .header-wrap p mark {\n        color: #EB298C;\n        background: none; }\n    ._c4937b9e .header-wrap * {\n      margin: 0.3125rem auto; }\n  ._c4937b9e nav {\n    position: absolute;\n    right: 0; }\n    ._c4937b9e nav a {\n      top: 8px;\n      right: 6px;\n      padding: 8px 12px;\n      color: #5badf0;\n      font-size: 13px;\n      line-height: 1.35;\n      border-radius: 3px;\n      font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n      ._c4937b9e nav a.cta {\n        background: #5badf0;\n        color: #fff;\n        margin-left: 12px; }\n") || true) && "_c4937b9e")

class Component extends Nanocomponent {
  constructor () {
    super()
  }

  createElement (state, emit) {
    return html`
      <header class=${prefix}>
        ${raw(header(state))}
      </header>
    `
  }

  update () {
    return true
  }
}

function clickButton (state, emit) {
  return () => {
    state.isDark = !state.isDark
    emit('render')
  }
}

module.exports = new Component()
